/* GiftInOne 2.14.27: optional local face assistance. Never joins editor busy or checkout. */
(function (window, document) {
  'use strict';
  if (window.GIOFaceAssist) return;
  var cache = typeof WeakMap === 'function' ? new WeakMap() : null;
  var worker = null, workerReady = null, readyResolve = null, disabled = false, nextId = 0;
  var requests = Object.create(null), active = 0, idleTimer = null, initTimer = null, workerBlob = null, fetchController = null;
  var generation = 0, warmRetryPending = false, warmRetryUsed = false, promoteReady = null;
  var names = { workerUrl: 'gio-face-worker.js', runtimeUrl: 'gio-face-runtime-0.10.21.js', loaderUrl: 'gio-face-wasm-loader-0.10.21.js', wasmUrl: 'gio-face-wasm-data-0.10.21.js', modelUrl: 'gio-face-model-1.js' };
  function unavailable(reason) { return { status: 'unavailable', faces: [], reason: reason }; }
  function config() {
    var settings = window.GIOEditorV2Config && window.GIOEditorV2Config.faceAssist;
    if (!settings || settings.enabled !== true) return null;
    var assets = {};
    try {
      Object.keys(names).forEach(function (key) {
        var url = new URL(String(settings[key] || ''), window.location.href);
        var allowed = url.hostname === window.location.hostname || url.hostname === 'cdn.shopify.com';
        if (url.protocol !== 'https:' || url.username || url.password || !allowed || !url.pathname.endsWith('/' + names[key])) throw new Error('Unsupported face asset');
        assets[key] = url.href;
      });
      return assets;
    } catch (_) { return null; }
  }
  function finish(id, result) {
    var request = requests[id];
    if (!request) return;
    delete requests[id]; active--; window.clearTimeout(request.timer); request.resolve(result);
    scheduleIdle(60000);
  }
  function scheduleIdle(milliseconds) {
    window.clearTimeout(idleTimer);
    if (active || !worker || readyResolve) return;
    var stamp = generation;
    idleTimer = window.setTimeout(function () { if (stamp === generation && !active) stop('idle', false); }, milliseconds);
  }
  function stop(reason, permanent) {
    generation++;
    if (permanent) disabled = true;
    window.clearTimeout(initTimer); window.clearTimeout(idleTimer);
    if (fetchController) { try { fetchController.abort(); } catch (_) {} fetchController = null; }
    if (worker) { try { worker.terminate(); } catch (_) {} worker = null; }
    if (workerBlob) { try { window.URL.revokeObjectURL(workerBlob); } catch (_) {} workerBlob = null; }
    if (readyResolve) { readyResolve(false); readyResolve = null; }
    workerReady = null; promoteReady = null;
    Object.keys(requests).forEach(function (id) { finish(id, unavailable(reason)); });
  }
  function ready(assets, speculative) {
    if (workerReady) {
      if (!speculative && readyResolve && promoteReady) promoteReady();
      return workerReady;
    }
    var stamp = ++generation;
    workerReady = new Promise(function (resolve) { readyResolve = resolve; });
    var promise = workerReady;
    function current() { return stamp === generation; }
    function fail(reason) {
      if (!current()) return;
      // A failed speculative load must not use up the first real photo's
      // chance to initialize. Retry only once, when a photo actually arrives.
      var canRetry = speculative && !active && !warmRetryUsed;
      stop(reason, true);
      if (canRetry) warmRetryPending = true;
    }
    initTimer = window.setTimeout(function () { fail('load-timeout'); }, 18000);
    promoteReady = function () {
      if (!current() || !speculative || !readyResolve) return;
      // Time spent browsing a native file chooser must not consume the
      // selected photo's initialization allowance. Promote only once; all
      // requests remain bounded by their own 24s detection deadline.
      speculative = false;
      window.clearTimeout(initTimer);
      initTimer = window.setTimeout(function () { fail('load-timeout'); }, 18000);
    };
    fetchController = typeof AbortController === 'function' ? new AbortController() : null;
    // Issue the small Worker fetch in the trusted click call itself. The
    // native picker can pause page tasks on some platforms; no await belongs
    // between that user gesture and input.click(). Heavy work stays in Worker.
    var fetchPromise;
    try { fetchPromise = window.fetch(assets.workerUrl, { credentials: 'omit', cache: 'force-cache', signal: fetchController && fetchController.signal }); }
    catch (_) { fail('load-unavailable'); return promise; }
    Promise.resolve(fetchPromise).then(function (response) {
      if (!current()) return null;
      if (!response.ok) throw new Error('Worker unavailable');
      return response.text();
    }).then(function (source) {
      if (!current() || disabled || !readyResolve) return;
      if (!source || source.length > 65536) throw new Error('Invalid worker source');
      workerBlob = window.URL.createObjectURL(new Blob([source], { type: 'application/javascript' }));
      worker = new Worker(workerBlob);
      var createdWorker = worker;
      worker.onerror = function () { if (worker === createdWorker) fail('worker-unavailable'); };
      worker.onmessageerror = function () { if (worker === createdWorker) fail('worker-unavailable'); };
      worker.onmessage = function (event) {
        if (!current() || worker !== createdWorker) return;
        var message = event.data || {};
        if (message.type === 'ready') {
          window.clearTimeout(initTimer); fetchController = null;
          if (workerBlob) { window.URL.revokeObjectURL(workerBlob); workerBlob = null; }
          if (readyResolve) { readyResolve(true); readyResolve = null; promoteReady = null; }
          scheduleIdle(speculative ? 120000 : 60000);
        } else if (message.type === 'init-error') fail('model-unavailable');
        else if (message.type === 'result') {
          var valid = Array.isArray(message.faces) && message.faces.length <= 20 && message.faces.every(function (box) {
            return box && [box.x, box.y, box.width, box.height, box.score].every(Number.isFinite) && box.x >= 0 && box.y >= 0 && box.width > 0 && box.height > 0 && box.x + box.width <= 1.000001 && box.y + box.height <= 1.000001 && box.score >= 0 && box.score <= 1;
          });
          finish(message.id, message.unavailable || !valid ? unavailable('detection-unavailable') : { status: 'ok', faces: message.faces });
        }
      };
      worker.postMessage({ type: 'init', assets: assets });
    }).catch(function () { fail('load-unavailable'); });
    return promise;
  }
  function prewarm() {
    try {
      var assets = config();
      if (disabled || !assets || !cache || typeof Worker !== 'function' || typeof window.fetch !== 'function' || typeof WebAssembly !== 'object') return Promise.resolve(false);
      var promise = ready(assets, true);
      scheduleIdle(120000);
      return promise;
    } catch (_) { return Promise.resolve(false); }
  }
  function detect(file, image) {
    try {
      if (cache && file && cache.has(file)) return cache.get(file);
      var assets = config();
      if ((disabled && !warmRetryPending) || !assets || !cache || !file || (typeof file !== 'object' && typeof file !== 'function') || typeof Worker !== 'function' || typeof window.fetch !== 'function' || typeof WebAssembly !== 'object') return Promise.resolve(unavailable('unsupported'));
      if (active >= 12) return Promise.resolve(unavailable('queue-full'));
      var width = Number(image && (image.naturalWidth || image.width)), height = Number(image && (image.naturalHeight || image.height));
      if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return Promise.resolve(unavailable('image-unavailable'));
      var scale = Math.min(1, 512 / Math.max(width, height)), canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(width * scale)); canvas.height = Math.max(1, Math.round(height * scale));
      var context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return Promise.resolve(unavailable('image-unavailable'));
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      var pixels = context.getImageData(0, 0, canvas.width, canvas.height), id = ++nextId;
      if (warmRetryPending) { warmRetryPending = false; warmRetryUsed = true; disabled = false; }
      var promise = new Promise(function (resolve) {
        active++; window.clearTimeout(idleTimer);
        requests[id] = { resolve: resolve, timer: window.setTimeout(function () { stop('detection-timeout', true); }, 24000) };
      });
      cache.set(file, promise);
      ready(assets, false).then(function (ok) {
        if (!requests[id]) return;
        if (!ok || !worker) { finish(id, unavailable('model-unavailable')); return; }
        try { worker.postMessage({ type: 'detect', id: id, width: pixels.width, height: pixels.height, pixels: pixels.data.buffer }, [pixels.data.buffer]); }
        catch (_) { finish(id, unavailable('worker-unavailable')); }
      }).catch(function () { finish(id, unavailable('model-unavailable')); });
      return promise;
    } catch (_) { return Promise.resolve(unavailable('detection-unavailable')); }
  }
  window.GIOFaceAssist = { detect: detect, prewarm: prewarm };
})(window, document);
